import React, { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/HistoryPage.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

function TamilHistory() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  const goToAbout = () => {
    navigate("/");

    setTimeout(() => {
      const section = document.getElementById("about");
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    }, 100);
  };

  return (
    <div className="history-page">
      <h2 data-aos="fade-up">வரலாற்றுச் சூழ்நிலை</h2>
      <p data-aos="fade-up" data-aos-delay="100">
        1816ஆம் ஆண்டு முதல் அமெரிக்கன் மிஷனைச் சேர்ந்த "அமெரிக்கன் சிலோன் மிஷன்" என்ற அமைப்பின் கீழ் யாழ்ப்பாணம் பகுதியில் நற்செய்திப் பணியாற்றி வந்தார்கள்.
        அந்த நாட்களில், தமிழர்கள் அதிகமாக வாழும் தமிழ்நாட்டில், மிக குறிப்பாக மதுரைப் பகுதியில் நற்செய்திப்பணி செய்ய வேண்டும் என்ற தங்கள்
        விருப்பத்தை பல அமெரிக்கன் மிஷன் கூட்ட நடவடிக்கைகளில் தெரிவித்து வந்தார்கள். இருப்பினும், அந்த விருப்பம் 18 ஆண்டுகள் கழித்து நிறைவேற ஆரம்பமானது.
        Rev.லேவி ஸ்பால்டிங் என்ற அமெரிக்கன் மிஷனரி தமிழ்நாட்டில் நற்செய்திப்பணி செய்வதற்கான இடத்தை கண்டறிந்து, பின்பு அமெரிக்கன் மிஷனுக்கு அறிக்கை சமர்ப்பித்து,
        அனுமதி பெற்று 1834ஆம் ஆண்டு ஜனவரி 10ஆம் தேதி இராமநாதபுரம் அருகில் உள்ள தேவிபட்டிணம் என்ற இடத்தில் வந்து இறங்கினார்.மதுரையிலிருந்து 1836 ம் ஆண்டு
        திருமங்கலத்திற்கு தங்கள் மிஷனரி பணியை விஸ்தாரம் செய்தார்கள்.1846-ம் ஆண்டு திருமங்கலம் வட்டார மிஷனரியாக Rev.ஜேம்ஸ் ஹேரிக் நியமிக்கப்பட்டார்.
        இவர் தொடர்ந்து 1883-ம் ஆண்டு வரை மொத்தம் 37ஆண்டுகள் இந்தப் பணியில் பணியாற்றினார் .மிகக் குறிப்பாக மல்லாங்கிணறு சித்துமூன்றடைப்பு ஆகிய பகுதியில் முதன்
        முதலாக நற்செய்தி பணி செய்தவரும் இவரே.
        <br /><br />
        <strong>சித்துமூன்றடைப்பு திருச்சபையின் ஆரம்ப காலம் :</strong><br />
        சித்துமூன்றடைப்பு கிராமத்தில் 1857ஆம் ஆண்டு முதல் திருமங்கலம் வட்டார மிஷனரியான Rev.ஜேம்ஸ் ஹெரிக், மல்லாங்கிணறு திருச்சபை குருவானவர் Rev.A.பெருமாள் மற்றும் உபதேசியார்கள் மூலம் நற்செய்திப்பணி ஆரம்பமானது. 1857ஆம் ஆண்டு சித்துமூன்றடைப்பில் இருந்த கிறிஸ்தவ மக்களின் எண்ணிக்கை மிகக் குறைவே. இருப்பினும் அவர்கள் கிறிஸ்தவ அறிவில் நன்றாகத் தேறி வந்தார்கள். பெண்களின் சமுதாய நிலை மிகவும் பின்தங்கிய நிலையில் இருந்தது. திருமணமான பெண் நற்செய்தியைக் கேட்பதில் மிகுந்த ஆர்வம் காட்டினார்கள். இவர்கள் நிலத்தில் பயிர் செய்வதிலும்,வியாபாரத்திலும் தங்களை ஈடுபடுத்திக் கொண்டிருந்தார்கள்.1859ஆம் ஆண்டு Rev.ஜேம்ஸ் ஹெரிக் மிஷனரியால் சித்துமூன்றடைப்பில் ஒரு புதிய திருச்சபை ஆரம்பிக்கபட்டது.




      </p>
      <h3 className="table-title" data-aos="fade-right">அமெரிக்கன் மிஷனரிகள்</h3>
      <table className="pastor-table" data-aos="zoom-in-up">
        <thead>
          <tr>
            <th>Pastor Name</th>
            <th>Years of Service</th>
          </tr>
        </thead>
        <tbody>
          {[
            { name: 'Rev. ஜேம்ஸ் ஹேரிக்', years: '1849–1883' },
            { name: 'Rev. J.E. திரேசி', years: '1884–1888' },
            { name: 'Rev. J.C. பெர்கின்ஸ்', years: '1889–1903' },
            { name: 'Rev. H.C. ஹாசன்', years: '1904–1909' },
            { name: 'Rev. J.E. ஜெப்ரி', years: '1910–1920' },
            { name: 'Rev. E.E. ஒயிட்', years: '1921–1940' }
          ].map((pastor, index) => (
            <tr key={index}>
              <td>{pastor.name}</td>
              <td>{pastor.years}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <h3 className="table-title" data-aos="fade-right" data-aos-delay="100">இந்திய குருமார்கள்</h3>
      <table className="pastor-table" data-aos="zoom-in-up" data-aos-delay="100">
        <thead>
          <tr>
            <th>Pastor Name</th>
            <th>Years of Service</th>
          </tr>
        </thead>
        <tbody>
          {[
            { name: 'Rev. R.G. டட்லி', years: '1941–1943' },
            { name: 'Rev. P.K. எட்வர்ட்', years: '1944–1946' },
            { name: 'Rev. G.P. ஜேம்ஸ்', years: '1947' },
            { name: 'Rev. G. துரைராஜ்', years: '1948' },
            { name: 'Rev. டேவிட் ஜான்', years: '1949–1952' },
            { name: 'Rev. E.J. எட்வின் செல்வராஜ்', years: '1953–1956' },
            { name: 'Rev. D. காலின்ஸ்', years: '1957–1961' },
            { name: 'Rev. K. ராபர்ட் முத்தையா', years: '1962–1963' },
            { name: 'Rev. S. பாக்கியநாதன்', years: '1964–1966' },
            { name: 'Rev. M.R. எபிநேசர்', years: '1967–1972' },
            { name: 'Rev. K. ராபர்ட் முத்தையா', years: '1973–1980' },
            { name: 'Rev. W. பால்ராஜ் சுவாமிதாஸ்', years: '1981–1988' },
            { name: 'Rev. R. அதிசயம்', years: '1989' },
            { name: 'Rev. J. தங்கையா', years: '1990–1991' },
            { name: 'Rev. T. ராயப்பா', years: '1992' },
            { name: 'Rev. P. ஜெயச்சந்திரன்', years: '1993–1996' },
            { name: 'Rev. A. கிறிஸ்டோபர் ஆசீர்', years: '1997–1998' },
            { name: 'Rev. S. ஜான்ராஷ் கமலம்', years: '1999–2003' },
            { name: 'Rev. G.K. செல்லப்பா', years: '2004–2005' },
            { name: 'Rev. K. ஏசுதாஸ்', years: '2006' },
            { name: 'Rev. G. சாம் செல்லப்பா', years: '2007' },
            { name: 'Rev. D. அன்புராஜ்', years: '2008' },
            { name: 'Rev. S. ஜோதிநாயகம்', years: '2009–2019' },
            { name: 'Rev. R. காளிதாசன் பீட்டர்', years: '2019–2026' },
            { name: 'Rev. A. தேவேந்திர குமார்', years: '2026–Present' }
          ].map((pastor, index) => (
            <tr key={index}>
              <td>{pastor.name}</td>
              <td>{pastor.years}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="history-buttons">
        <button
          onClick={goToAbout}
          className="history-btn history-btn-back"
        >
          Back to About
        </button>

        <Link to="/history" className="history-btn history-btn-primary">
          Translate to English
        </Link>
      </div>

    </div>


  );
}

export default TamilHistory;
